import { Box, Card, CardContent, Typography } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonIcon from '@mui/icons-material/Person';
import { format, parseISO } from 'date-fns';
import { PotStatusBadge } from '../PotStatusBadge';
import type { PotDetailsDisplayModel } from '../../types/potDetails.types';
import type { PotStatus } from '../../types/pot.types';

interface PotHeaderCardProps {
  potDetails: PotDetailsDisplayModel;
}

export function PotHeaderCard({ potDetails }: PotHeaderCardProps) {
  const { owner, period, approvals, deadlines } = potDetails;

  const formatDateRange = (start: string, end: string) => {
    const startFormatted = format(parseISO(start), 'dd MMM');
    const endFormatted = format(parseISO(end), 'dd MMM yyyy');
    return `${startFormatted} – ${endFormatted}`;
  };

  return (
    <Card variant="outlined" data-testid="pot-header-card">
      <CardContent
        sx={{ p: { xs: 2, sm: 3 }, '&:last-child': { pb: { xs: 2, sm: 3 } } }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 }}>
          {owner.ownerType === 'Gang' ? (
            <GroupsIcon sx={{ color: 'text.secondary' }} />
          ) : (
            <PersonIcon sx={{ color: 'text.secondary' }} />
          )}
          <Typography variant="h6" fontWeight={600}>
            {owner.ownerName}
          </Typography>
          <PotStatusBadge status={approvals.status as PotStatus} />
        </Box>
        {approvals.status === 'MissedVerificationDeadline' &&
          deadlines?.verifyBy && (
            <Typography
              variant="body2"
              color="warning.main"
              data-testid="pot-verify-deadline"
            >
              Verify by {format(parseISO(deadlines.verifyBy), 'dd MMM yyyy')}
            </Typography>
          )}
        <Typography variant="body2" color="text.secondary">
          Week {period.weekNumber}, {period.year} &middot;{' '}
          {formatDateRange(period.start, period.end)}
        </Typography>
      </CardContent>
    </Card>
  );
}
